import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const VideoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 100%;
  height: 100%;
  overflow: hidden;

  &:before {
    display: ${(props) => (props.scrim ? 'block' : 'none')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  video {
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    object-fit: cover;
    object-position: center center;
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media (max-width: 900px) {
      width: 100%;
      min-height: 100%;
    }
  }
`;

const Video = ({ src, poster, scrim }) => {
  return (
    <VideoWrapper
      scrim={scrim}
      dangerouslySetInnerHTML={{
        __html: `
               <video
                  muted
                  autoplay
                  playsinline
                  loop
                  src="${src}"
                  poster="${poster}"
               />
            `,
      }}
    />
  );
};

Video.propTypes = {
  src: PropTypes.string,
  poster: PropTypes.string,
  scrim: PropTypes.bool,
};

Video.defaultProps = {
  src: '',
  poster: '',
  scrim: false,
};

export default Video;
